import type {RichTextField} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import type {FC} from 'react'
import {memo} from 'react'

interface DescriptionSectionProps {
  description: RichTextField
}

export const DescriptionSection: FC<DescriptionSectionProps> = memo(({description}) => (
  <div>
    <PrismicRichText
      field={description}
      components={{
        paragraph: ({children}) => (
          <p className="md:text-tg-body-l w-full max-w-[400px] text-center text-16 leading-[22px] text-moss-white/[70%]">
            {children}
          </p>
        ),
      }}
    />
  </div>
))

DescriptionSection.displayName = 'DescriptionSection'
